import { CheckMarkCircleSmall, DeleteIcon } from '../../../components'
import CancelIcon from '@mui/icons-material/Cancel'
import { Delivery, ThinDelivery } from '../../../types'
import { IconContainer } from '../../Settings/Wheat/EquinomBins/EquinomBins.styled'

export const consistencyIcons = {
  checkmark: {
    icon: <CheckMarkCircleSmall />,
  },
  exclamation: {
    icon: <CancelIcon fontSize="medium" />,
  },
  default: {
    icon: <CheckMarkCircleSmall />,
  },
}

export const handleDeliveryIcon = (delivery: Delivery | ThinDelivery) => {
  if (delivery?.discarded) {
    return <DeleteIcon size={22} />
  }

  return (
    <IconContainer color={delivery?.consistency?.color?.hex_code || 'green'}>
      {consistencyIcons[delivery.consistency?.icon_name || 'default'].icon}
    </IconContainer>
  )
}
